/**
 * Channels sidebar and Add Channel policy.
 * One UI row per platform connection. WhatsApp phone numbers stay inside WhatsApp management.
 * Commercial-plan endpoint counting is unchanged.
 */
export const CHANNEL_PLATFORM_IDS = ["whatsapp", "facebook", "instagram"] as const;

export type ChannelPlatformId = (typeof CHANNEL_PLATFORM_IDS)[number];

export function isChannelSidebarVisible(state: string): boolean {
  return state !== "NOT_CONNECTED" && state !== "DISCONNECTED";
}

/** Connected and in-progress setups cannot start another platform connection. */
export function isChannelAddOptionDisabled(state: string): boolean {
  return (
    state === "CONNECTED" ||
    state === "PENDING_PHONE_SELECTION" ||
    state === "PENDING_PAGE_SELECTION"
  );
}

export function isChannelConnected(state: string): boolean {
  return state === "CONNECTED";
}

export function channelStatusLabelKey(state: string): string {
  switch (state) {
    case "CONNECTED":
      return "channels.status.connected";
    case "PENDING_PHONE_SELECTION":
    case "PENDING_PAGE_SELECTION":
      return "channels.status.pending";
    case "DISCONNECTED":
      return "channels.status.disconnected";
    case "ERROR":
      return "channels.status.error";
    case "NOT_CONNECTED":
      return "channels.status.notConnected";
    default:
      return "channels.status.notConnected";
  }
}
